import { useCallback } from "react";
import { authFetch } from "./utils/authFetch";
import { toast } from "react-toastify";

export const useReviewApi = () => {
  const createReview = async (
    auctionId: string,
    rating: number,
    comment?: string
  ) => {
    const res = await authFetch(
      `${process.env.REACT_APP_API_URL}/api/reviews`,
      {
        method: "POST",
        body: JSON.stringify({ auctionId, rating, comment }),
      }
    );

    if (!res.ok) {
      const errorText = await res.text();
      toast.error(errorText || "Failed to submit review.");
      return;
    }

    toast.success("Review submitted successfully.");

    return;
  };

  const getCompanyReviews = useCallback(
    async (companyId: string, skip = 0, take = 20) => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/reviews/company/${companyId}?skip=${skip}&take=${take}`
      );

      if (!res.ok) {
        toast.error("An error occurred while getting the reviews.");
        throw new Error(`Failed to fetch company reviews (${res.status})`);
      }

      return await res.json();
    },
    []
  );

  return {
    createReview,
    getCompanyReviews,
  };
};
